import React, { useEffect, useState } from 'react';
import BannerImg from '../../assets/images/banner_img.webp';
import AboutImg from '../../assets/images/alka.webp';
import AppointmentImg from '../../assets/images/appointment-booking.webp';
import CommonCold from '../../assets/images/common-cold.png';
import Cough from '../../assets/images/cough.png';
import Urti from '../../assets/images/urti.png';
import Flu from '../../assets/images/flu.png';
import Urinary from '../../assets/images/urinary.png';
import Headaches from '../../assets/images/headaches.png';
import Earache from '../../assets/images/earache.png';
import Vomiting from '../../assets/images/vomiting.png';
import SoreThroat from '../../assets/images/sore-throat.png';
import Sinus from '../../assets/images/sinus.png';
import Allergies from '../../assets/images/allergies.png';
import SkinRash from '../../assets/images/skin-rash.png';
import Diarrhoea from '../../assets/images/diarrhoea.png';
import Indigestion from '../../assets/images/indigestion.png';
import EyeInfection from '../../assets/images/eye-infection.png';
import { Link } from 'react-router-dom';
import { faq, testimonials, setting } from '../../redux/reducers/HomePageSlice';
import { useDispatch } from 'react-redux';
// SEO helpers (meta tags + structured data)
import PageSEO from '../../SEO/PageSEO';
import { getFAQSchema } from '../../SEO/StructuredData';

const Home = () => {
  const dispatch = useDispatch();
  const [faqData, setFaqData] = useState();
  const [testimonialsData, setTestimonialsData] = useState();
  const [blog, setBlog] = useState();

  // Sample FAQ data for structured data
  const sampleFAQs = [
    {
      question: "How does online doctor consultation work?",
      answer: "Our online consultation allows you to book an appointment with certified doctors and have a video call consultation from the comfort of your home."
    },
    {
      question: "Is the consultation secure and private?",
      answer: "Yes, all consultations are encrypted and follow strict privacy protocols to ensure your medical information remains confidential."
    }
  ];

  useEffect(() => {
    const settingData = async () => {
      try {
        const responseSetting = await dispatch(setting());
        setBlog(responseSetting.payload.data.blog_posts);
      } catch (error) {
        // Error fetching setting data
      }
    };
    settingData();
  }, [dispatch]);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      if (!testimonialsData || testimonialsData.length === 0) return;

      // Lazy-load jquery + slick to reduce main-thread work during initial page load (improves LCP/TBT).
      const { default: $ } = await import('jquery');
      await import('slick-carousel/slick/slick.css');
      if (typeof window.$ === 'undefined') {
        window.$ = $;
      }
      await import('slick-carousel');
      if (cancelled) return;

      const $slider = $('.review_slider');
      if ($slider.length && !$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 4000,
          dots: true,
          arrows: false,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 1400,
              settings: { slidesToShow: 2 },
            },
            {
              breakpoint: 992,
              settings: { slidesToShow: 1 },
            },
          ],
        });
      }
    })();

    return () => {
      cancelled = true;
      import('jquery').then(({ default: $ }) => {
        const $slider = $('.review_slider');
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }).catch(() => { });
    };
  }, [testimonialsData]);
  useEffect(() => {
    const faqData = async () => {
      try {
        const responceFaq = await dispatch(faq());
        setFaqData(responceFaq.payload.data);
      } catch (error) {
        // Error fetching data
      }
    };
    const testimonialsData = async () => {
      try {
        const responceTestimonials = await dispatch(testimonials());
        setTestimonialsData(responceTestimonials.payload.data);
      } catch (error) {
        // Error fetching data
      }
    };
    faqData();
    testimonialsData();
  }, [dispatch]);

  return (
    <>
      <PageSEO
        page="home"
        structuredData={[getFAQSchema(sampleFAQs)]}
      />
      <section
        className="banner"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/demo-medical-hero-banner-bg.jpg)` }}
      >
        <div className="container">
          <div className="row justify-content-between">
            <div
              className="col-xxl-6 col-md-9 col-xl-6 col-lg-6">
              <div className="banner_text">
                <h5>Welcome to TELEDOC</h5>
                <h1 style={{ textAlign: 'left' }}>Book Appointment with TELEDOC</h1>
                {/* NOTE: Avoid <div> wrappers here because global CSS `.banner div { height: 100%; }` stretches them */}
                <ul className="d-flex flex-wrap gap-3 mb-2 list-unstyled" style={{ paddingLeft: 0 }}>
                  <li>
                    <article className="p-3 border rounded-3 shadow-sm" style={{ textAlign: 'left', backgroundColor: '#e6f6f6', whiteSpace: 'nowrap' }}>
                      <span className="d-flex align-items-center" style={{ gap: 12 }}>
                        <i className="fas fa-video text-primary" style={{ fontSize: 20 }} />
                        <span>
                          <span style={{ fontWeight: 700, fontSize: 16, display: 'block' }}>Online Consultation</span>
                          <span style={{ fontSize: 13, color: '#6c757d', display: 'block' }}>Video consult from home</span>
                        </span>
                      </span>
                    </article>
                  </li>
                  <li>
                    <article className="p-3 border rounded-3 shadow-sm" style={{ textAlign: 'left', backgroundColor: '#e6f6f6', whiteSpace: 'nowrap' }}>
                      <span className="d-flex align-items-center" style={{ gap: 12 }}>
                        <i className="fas fa-stethoscope text-primary" style={{ fontSize: 20 }} />
                        <span>
                          <span style={{ fontWeight: 700, fontSize: 16, display: 'block' }}>2nd Opinion</span>
                          <span style={{ fontSize: 13, color: '#6c757d', display: 'block' }}>For your medical condition</span>
                        </span>
                      </span>
                    </article>
                  </li>
                </ul>
                <p style={{ marginBottom: 8 }}>
                  <strong>Starting at ₹500.</strong> Follow-up within 7 days: <strong>₹250</strong>.
                </p>
                <p>
                  Book in 60 seconds. Secure & confidential.
                </p>
                <Link to='/book-appointment' className="common_btn">Book an Appointment</Link>
                <ul className="banner_counter d-flex flex-wrap">
                  <li className='pt-[20px]'>
                    <h3>
                      <span className="counter">15</span>+ yrs.
                    </h3>
                    <p>of Medical Experience</p>
                  </li>
                  <li>
                    <h3>
                      <span className="counter">98</span>%
                    </h3>
                    <p>Satisfactory Reviews                    </p>
                  </li>
                  <li>
                    <h3>
                      <span className="counter">25000</span>+
                    </h3>
                    <p>patient consultations done</p>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="col-xxl-6 col-lg-6 col-xl-6">
              <div className="banner_img">
                <div className="img">
                  <img
                    src={BannerImg}
                    alt="Patient consultation"
                    className="img-fluid w-100"
                    fetchpriority="high"
                    width="620"
                    height="740"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about_2 pt_50 pb_50" id="about">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 wow fadeInLeft" data-wow-duration="1s">
              <div className="about_2_img">
                <img src={AboutImg} className="img-fluid" alt="Dr Alka Sori" loading="lazy" width="530" height="545" />
              </div>
            </div>
            <div className="col-lg-6 wow fadeInRight" data-wow-duration="1s">
              <div className="about_2_text">
                <div className="common_heading home_tow_heading">
                  <h2>Dr. Alka Sori</h2>
                  <p className="about-highlight-box">
                    Ex Asst. Registrar, Ministry of Health, Government of Kuwait<br />
                    Ex Dubai Health Authority License Holder<br />
                    Ex General Medical Council (GMC), UK License Holder<br />
                    Total 15 years of experience across India, UK & Middle East.<br />
                  </p>
                  <p>
                    Dr Alka Sori is Director, General Physician and Telemedicine
                    Specialist at Teledoc. She graduated from WHO (World Health
                    Organization) listed – Government Medical college, Amritsar
                    in India and has more than 15 years of experience in various
                    health setups across India, UK, UAE & Kuwait.
                  </p>
                  <p>
                    She has also accomplished MSc, Clinical Research from
                    University of Sheffield, UK and has an NHS publication in
                    Elsevier
                    <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8447542/" target="_blank" rel="noreferrer"> &nbsp;(Read Article)
                    </a>
                  </p>
                  <p>
                    She is registered with Medical Council of India (MCI) and
                    held registrations from GMC (General Medical Council), UK,
                    DHA (Dubai Health Authority), UAE & Ministry of Health
                    Kuwait. She has been practicing Telemedicine in UAE & India
                    focusing on Primary Care & Internal Medicine.
                  </p>
                  <p>
                    Dr Alka chose family medicine as it is the cornerstone of
                    medicine, health education and primary care. She believes in
                    treating a patient and not the diagnosis. Dedicated to
                    providing exceptional care services while maintaining
                    confidentiality.
                  </p>
                  <p>
                    She is fluent in English, Arabic, Hindi and Punjabi. In her
                    spare time, she enjoys painting (she is a Mandala Artist),
                    cycling and travelling.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="get_touch_2 pt_50 pb_50">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 wow fadeInLeft" data-wow-duration="1s">
              <div className="common_heading home_tow_heading mb_15">
                <h2>Skip the hassle of visiting a Doctor!</h2>
                <p>
                  Book your video consultation now. Get the best Medical consultation & treatment online.
                </p>
                <Link to="/book-appointment" className="common_btn">
                  Book an Appointment
                </Link>
              </div>
            </div>
            <div className="col-lg-6 wow fadeInRight" data-wow-duration="1s">
              <div className="video_box">
                <img src={AppointmentImg} alt="Online Doctor Appointment Booking" className="img-fluid" loading="lazy" width="600" height="600" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="service pt-5 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="common_heading center_heading mb_15">
                <h2>What We Treat</h2>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-md-2 col-6 text-center mb-4">
              <img src={CommonCold} alt="Common Cold Treatment Online" className="img-fluid" loading="lazy" />
              <h4 className="fs-5 pt-3">Common Cold</h4>
            </div>
            <div className="col-md-2 col-6 text-center mb-4">
              <img src={Cough} alt="Cough Calculator and Treatment" className="img-fluid" loading="lazy" />
              <h4 className="fs-5 pt-3">Cough</h4>
            </div>
            <div className="col-md-2 col-6 text-center mb-4">
              <img src={Urti} alt="Upper Respiratory Tract Infection Treatment" className="img-fluid" loading="lazy" />
              <h4 className="fs-5 pt-3">URTI</h4>
            </div>
            <div className="col-md-2 col-6 text-center mb-4">
              <img src={Flu} alt="Flu and Viral Fever Treatment" className="img-fluid" loading="lazy" />
              <h4 className="fs-5 pt-3">Flu like illness</h4>
            </div>
            <div className="col-md-2 col-6 text-center mb-4">
              <img src={Urinary} alt="Urinary Tract Infection Consultation" className="img-fluid" loading="lazy" />
              <h4 className="fs-5 pt-3">Urinary Symptoms</h4>
            </div>
            <div className="col-md-2 col-6 text-center mb-4">
              <img src={Headaches} alt="Migraine and Headache Relief" className="img-fluid" loading="lazy" />
              <h4 className="fs-5 pt-3">Headaches</h4>
            </div>
            <div className="col-md-2 col-6 text-center mb-4">
              <img src={Earache} alt="Ear Pain Treatment Online" className="img-fluid" loading="lazy" />
              <h4 className="fs-5 pt-3">Earaches</h4>
            </div>
            <div className="col-md-2 col-6 text-center mb-4">
              <img src={Vomiting} alt="Vomiting and Nausea Treatment" className="img-fluid" loading="lazy" />
              <h4 className="fs-5 pt-3">Vomiting</h4>
            </div>
            <div className="col-md-2 col-6 text-center mb-4">
              <img src={SoreThroat} alt="Sore Throat Infection Cure" className="img-fluid" loading="lazy" />
              <h4 className="fs-5 pt-3">Sorethroat</h4>
            </div>
            <div className="col-md-2 col-6 text-center mb-4">
              <img src={Sinus} alt="Sinusitis Treatment Video Call" className="img-fluid" loading="lazy" />
              <h4 className="fs-5 pt-3">Sinus Congestion</h4>
            </div>
            <div className="col-md-2 col-6 text-center mb-4">
              <img src={Allergies} alt="Skin Allergy and Rash Doctor" className="img-fluid" loading="lazy" />
              <h4 className="fs-5 pt-3">Allergies</h4>
            </div>
            <div className="col-md-2 col-6 text-center mb-4">
              <img src={SkinRash} alt="Dermatology and Skin Problems" className="img-fluid" loading="lazy" />
              <h4 className="fs-5 pt-3">Skin Rashes</h4>
            </div>
            <div className="col-md-2 col-6 text-center mb-4">
              <img src={Diarrhoea} alt="Diarrhea Treatment Online" className="img-fluid" loading="lazy" />
              <h4 className="fs-5 pt-3">Diarrhoea</h4>
            </div>
            <div className="col-md-2 col-6 text-center mb-4">
              <img src={Indigestion} alt="Stomach Pain and Indigestion" className="img-fluid" loading="lazy" />
              <h4 className="fs-5 pt-3">Indigestion</h4>
            </div>
            <div className="col-md-2 col-6 text-center mb-4">
              <img src={EyeInfection} alt="Eye Infection Doctor Consultation" className="img-fluid" loading="lazy" />
              <h4 className="fs-5 pt-3">Eye Infections</h4>
            </div>
          </div>
        </div>
      </section>
      <section className="process pt_50 pb_50">
        <div className="container-fluid process_shape">
          <div className="row">
            <div className="col-xl-12">
              <div className="common_heading center_heading mb_25">
                <h5>How We Work</h5>
                <h2>Our Working Process</h2>
              </div>
            </div>
          </div>
          <div className="work_process_area">
            <div className="row text-center">
              <div className="col-md-2 wow fadeInUp" data-wow-duration="1s">
                <div className="single_process">
                  <span className="process_number num1">01</span>
                  <h4>Create an Account</h4>
                  <p>
                    Enter your basic information. Once you have activated your
                    account, you will be able to login and set up a video
                    consultation for immediate access to a doctor.
                  </p>
                </div>
              </div>
              <div className="col-md-2 wow fadeInUp" data-wow-duration="1s">
                <div className="single_process">
                  <span className="process_number num2">02</span>
                  <h4>Book Video Consultation</h4>
                  <p>
                    Enter symptoms experienced by yourself or your child,
                    indicate if you have any allergies and upload a photo if
                    necessary.
                  </p>
                </div>
              </div>
              <div className="col-md-2 wow fadeInUp" data-wow-duration="1s">
                <div className="single_process">
                  <span className="process_number num3">03</span>
                  <h4>Payment</h4>
                  <p>
                    Select a subscription plan to get access to unlimited
                    consultations or pay as you go each time you use the app.
                  </p>
                </div>
              </div>
              <div className="col-md-2 wow fadeInUp" data-wow-duration="1s">
                <div className="single_process">
                  <span className="process_number num4">04</span>
                  <h4>Video Consultation</h4>
                  <p>
                    Conduct a video consultation. You will be able to turn off
                    your camera and you can also extend the length of your
                    consultation whilst you are on your video call.
                  </p>
                </div>
              </div>
              <div className="col-md-2 wow fadeInUp" data-wow-duration="1s">
                <div className="single_process">
                  <span className="process_number num5">05</span>
                  <h4>Review Reports</h4>
                  <p>
                    Check My History and read your detailed doctor’s report with
                    actionable medical recommendations.
                  </p>
                </div>
              </div>
              <div className="col-md-2 wow fadeInUp" data-wow-duration="1s">
                <div className="single_process">
                  <span className="process_number num6">06</span>
                  <h4>Follow Up</h4>
                  <p>Follow up with doctor again if Required</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="faq pt_50 pb_50" id="faqs">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="common_heading center_heading mb_25">
                <h5>FAQ</h5>
                <h2>Frequently Asked Questions</h2>
              </div>
            </div>
          </div>
          <div
            className="faq_accordion accordion accordion-flush"
            id="accordionFlushExample">
            <div className="row">
              {faqData?.map((faq, index) => (
                <div
                  key={index}
                  className="col-md-6 wow fadeInLeft"
                  data-wow-duration="1s">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id={`faqHeading${index}`}>
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#faq${index}`}
                        aria-expanded="true"
                        aria-controls={`faq${index}`}>
                        {faq.title}
                      </button>
                    </h2>
                    <div
                      id={`faq${index}`}
                      className="accordion-collapse collapse"
                      aria-labelledby={`faqHeading${index}`}
                      data-bs-parent="#accordionFlushExample">
                      <div className="accordion-body">{faq.content}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className="review pt_50 pb_50" id="testimonials">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="common_heading center_heading mb_45">
                <h5>Testimonials</h5>
                <h2>What Our Client Says</h2>
              </div>
            </div>
          </div>
          {!testimonialsData ? (
            <p>Loading testimonials...</p>
          ) : (
            <div className="row review_slider">
              {testimonialsData.map((testimonial, index) => (
                <div key={index} className="col-xl-4">
                  <div className="single_review">
                    <p>{testimonial.content}</p>
                    <div className="reviewer_info">
                      <h3>{testimonial.client_name}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
      <section className="blog pt_50 pb_50" id="blog">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="common_heading center_heading mb_15">
                <h5>Latest News</h5>
                <h2>Latest Post & Articles</h2>
              </div>
            </div>
          </div>
          <div className="row">
            {blog?.length > 0 ? (
              <div className="row">
                {blog.map((item, index) => (
                  <div key={index} className="col-xl-4 col-md-6 col-lg-4 wow fadeInUp" data-wow-duration="1s">
                    <div className="single_blog">
                      <div className="blog_img">
                        <img src={item.image} alt={item.title} className="img-fluid w-100" loading="lazy" />
                      </div>
                      <div className="blog_text">
                        <ul className="d-flex flex-wrap blog_date">
                          <li>
                            <i className="fas fa-calendar-alt"></i>{item.date.split(" ")[0]}
                          </li>
                        </ul>
                        <a href={item.url} target="_blank" rel="noreferrer" className="blog_heading" dangerouslySetInnerHTML={{ __html: item.title }}></a>
                        <p
                          dangerouslySetInnerHTML={{ __html: item.content.split(' ').slice(0, 20).join(' ') + '...' }}
                        ></p>
                        <a
                          href={item.url}
                          target="_blank"
                          rel="noreferrer"
                          className="blog_link"
                        >
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p>Loading...</p>
            )}
          </div>
          <div className="d-flex justify-content-center mt-4">
            <Link to='https://teledoc.co.in/blog/' target='_blank' rel="noreferrer" className="common_btn">View all Posts</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
